/**
 * @flow
 */
import {Action, Dispatch} from 'redux'

export interface ModalState {
  open: boolean;
  message: string;
  title: string;
  style: 'alert' | 'confirm' | 'error';
  onOk?: () => void;
}

export interface ModalAction extends Action {
  open: boolean;
  message: string;
  title: string;
  style: 'alert' | 'confirm';
  onOk?: () => void;
  error?: Error;
}

export function modalReducer(state: ModalState = {}, action: ModalAction): ModalState {
  const {type, ...rest} = action;
  if(type === 'MODAL_UPDATE') {
    return {...state, ...rest};
  } else {
    return state;
  }
}

export function closeModal(dispatch: Dispatch) {
  dispatch({type: 'MODAL_UPDATE', open: false});
}

export function openAlert(dispatch: Dispatch, message, title) {
  dispatch({type: 'MODAL_UPDATE', open: true, title, message, error: null, style: 'alert'});
}

export function openAlertError(dispatch: Dispatch, error: Error, title) {
  dispatch({type: 'MODAL_UPDATE', open: true, title, message: null, error, style: 'alert'});
}

export function openConfirm(dispatch: Dispatch, message, title, onOk) {
  dispatch({type: 'MODAL_UPDATE', open: true, title, message, onOk, style: 'confirm'});
}
